export default "__VITE_ASSET__Zx1s5_1K__"